// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CollapseClose: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
            overflow="visible"
        >
            <g fill="none" fillRule="evenodd">
                <circle cx="8" cy="8" r="7.5" stroke="currentColor" opacity=".33" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M13 8a.77.77 0 01-.77.77H3.77a.77.77 0 110-1.539h8.46c.426 0 .77.344.77.769z"
                />
            </g>
        </svg>
    );
};

export default React.memo(CollapseClose);
